module.exports = require('../../full/array/of');
